import styled from 'styled-components'
import tw from 'twin.macro'

export const HotToastContainer = styled.div`
  ${tw` relative`}
`

export const IconWrapper = styled.div`
  ${tw`flex-shrink-0 pt-0.5`}
`

export const IconAndErrorMessageWrapper = styled.div`
  ${tw`flex items-start`}
`

export const ToastMessageWrapper = styled.div`
  ${tw`ml-2 flex-1`}
`

export const ToastMessageText = styled.p`
  ${tw`text-sm leading-5 font-medium text-red-800`}
`

export const ToastMessageContainer = styled.div`
  ${tw`flex-1 w-0`}
`

export const ToastContainer = styled.div`
  ${tw`max-w-md w-full bg-red-50 border rounded-xl border-red-500  shadow-lg rounded-lg pointer-events-auto flex px-4 py-3 mb-8`}
  box-shadow:
  0 10px 10px -5px rgba(0, 0, 0, 0.04), 0 20px 25px -5px rgba(0, 0, 0, 0.1),
`
